import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate,useLocation,useParams, Link} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { FaAngleDoubleLeft } from "react-icons/fa";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const { Option } = Select;
const { TextArea } = Input;

const LeadsProcessed = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const venueId = queryParams.get('venue_id');

  var month = JSON.parse(localStorage.getItem('month'));
  var year = JSON.parse(localStorage.getItem('year'));

  const [loading, setLoading] = useState(true)
  const [selectedVenueId, setSelectedVenueId] = useState(venueId)
  const [venueName, setVenueName] = useState('')
  const [leadData, setLeadData] = useState([])
  const [header, setHeader] = useState([])

  useEffect(() => {
    setLoading(true)
    getLeadsDayByDay()
  }, [selectedVenueId]); 

  const getLeadsDayByDay= () => {
    var date = year + '-' + month + '-01'
    getData(`/eagleeye/getTableData/?report_id=76377&venue_id=${selectedVenueId}&date=${date}`)
    .then(response =>{
      setHeader(response.headers)
      setLeadData(response.data)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const columns = header.map((header, index) => ({
    title: header,
    dataIndex: index.toString(),
    key: header,
    align: 'center',
    render: (text) => {
        const linkMatch = text.match(/<a .*?href="(.*?)".*?>(.*?)<\/a>/);
        
        if (linkMatch) {
            const href = `${linkMatch[1]}&venue_id=${venueId}`;
            const linkText = linkMatch[2];
            
            return (
                <Link className="venueTitle" to={href}>
                    {linkText}
                </Link>
            );
        }

        return <span className="venueTitle">{text}</span>;
    }
  }));  

  const rowData = leadData.map((row, rowIndex) => {
      const rowObj = {};
      row.forEach((cell, cellIndex) => {
          rowObj[cellIndex] = cell;
      });
      return { key: rowIndex, ...rowObj };
  });

const chartData = leadData.map((row) => {
  const extractNumber = (value) => {
    if (typeof value === 'string') {
      const linkMatch = value.match(/>([\d]+)</);
      if (linkMatch) return parseInt(linkMatch[1], 10);
      return parseInt(value, 10) || 0;
    }
    return 0;
  };

  return {
    day: row[0],
    leads_processed: extractNumber(row[1]),
    demo_scheduled: extractNumber(row[2]), 
    demo_attended: extractNumber(row[3]) 
  };
}).reverse();

  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.Header active={true}>
          <a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate('/leads-processed')}><FaAngleDoubleLeft/></a>
           <a>Leads Processed </a>
           <a></a>
        </Styled.Header>
        <Styled.LeadGraphContainer>
          <Styled.GraphDiv>
            <Styled.GraphDivLabelDiv>
              <Styled.LabelHeading> Leads Processed - Analysis </Styled.LabelHeading>          
            </Styled.GraphDivLabelDiv>

            {loading ? 
                <div style={{ height: '28vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Spin />
                </div>
              :
                <ResponsiveContainer width="100%" height="80%">
                  <LineChart width={400} height={400} data={chartData} margin={{top: 5, right: 10, left: 5, bottom: 5}}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis 
                      dataKey="day" 
                      angle={-45}
                      textAnchor="end"
                      height={80}
                    />
                    <YAxis/>
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="leads_processed" stroke="#4345ab" name="Lead Processed"/>  
                    <Line type="monotone" dataKey="demo_scheduled" stroke="#c48e1a" name="Demo Scheduled"/>
                    <Line type="monotone" dataKey="demo_attended" stroke="#1e7c0a" name="Demo Attended"/>
                  </LineChart>
                </ResponsiveContainer>
              }

          </Styled.GraphDiv>
        </Styled.LeadGraphContainer>
        <Table
          className="ant-table-thead"
          rowKey="id"
          columns={columns} 
          dataSource={rowData}
          pagination={false}
         />

      </Styled.MainContainer>

    </Spin>
  );
}

export default LeadsProcessed;